// Vendor libs
import React, {useContext, useState} from 'react';
import PropTypes from 'prop-types';

// Material UI
import {AppBar, CssBaseline, makeStyles, Toolbar, Typography} from '@material-ui/core';
import OpacityIcon from '@material-ui/icons/Opacity';

// Images
import {Logout} from '@dishtech-react/core';
import logo from '../assets/logo.svg';

// Context
import {RouteContext} from '../contexts/route-context';

const useStyles = makeStyles((theme) => ({
  headerBlock: {flexGrow: 1, alignItems: 'center', marginRight: 10},
  headerText: {marginLeft: 20},
  headerIcon: {fontSize: 30, color: theme.palette.secondary.main},
  headerUser: {marginRight: 10},
}));

const Layout = ({children, userName, email}) => {
  const routeContext = useContext(RouteContext);
  const [isLogoutOpen, setLogoutOpen] = useState(false);
  const classes = useStyles();

  return (
    <div className="app">
      <CssBaseline />
      <AppBar color="primary">
        <Toolbar>
          <img alt="Dish Network" src={logo} width={75} />
          <Typography className={classes.headerBlock} variant="h5">
            <span className={classes.headerText}>RAINDROP</span>
            <OpacityIcon className={classes.headerIcon} />
          </Typography>

          <span className={classes.headerUser}>{`${userName && userName?.toUpperCase()}:${email}`}</span>
          <Logout
            isLogoutOpen={isLogoutOpen}
            logoutAllApps={true}
            routeContext={routeContext}
            setLogoutOpen={setLogoutOpen}
            showIcon={true}
            textCaseUpper={true}
          />
        </Toolbar>
      </AppBar>
      <main>{children}</main>
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.array,
  email: PropTypes.string,
  userName: PropTypes.string,
};

export default Layout;
